import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { makeDefault } from "../redux/regionsSagas";

export const SetAsDefault = ({ isOpen, onClose, selectedRegion = {} }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(makeDefault(selectedRegion.id));
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      containerClassName="dialog"
      parentSelector=".regions"
      width={350}
      height="auto"
      headerCloseHandler={close}
      primaryButtonText="Yes"
      primaryBtnHandler={primaryBtnHandler}
      secondaryBtnText="No"
      secondaryBtnHandler={onClose}
      onClose={onClose}
    >
      Do you want to set <span className="text-bold">{selectedRegion.name}</span> Region as Default
      for new Sites?
    </MainModal>
  );
};
